<template>
  <div>
    <v-row
      no-gutters
      class="flex-column"
      justify="center"
      align="center"
    >
      <v-col
        cols="auto"
        class="mb-1"
      >
        <v-sheet
          elevation="4"
          width="30"
          height="30"
          style="border-radius: 50%; background: radial-gradient(circle, #ffffff, #cccccc);
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 8px 10px rgba(0, 0, 0, 0.1), 0 12px 20px rgba(0, 0, 0, 0.1);
          display: flex; justify-content: center; align-items: center; font-size: 11px; text-align: center; font-weight: bold"
        >
          {{ position.short_name }}
        </v-sheet>
      </v-col>
      <v-col
        cols="auto"
        class="pb-0"
      >
        <v-card
          width="140"
          outlined
          style="opacity: 0.95;"
        >
          <v-card-text class="pa-1">
            <draggable
              :list="players"
              handle=".handle"
              :group="{ name: 'players' }"
              :invert-swap="true"
              :swap-threshold="0.6"
              :animation="100"
              @change="updateOrder()"
              @end="updateOrder()"
            >
              <div
                v-for="(player, index) in players"
                :key="player.id"
              >
                <div
                  class="text-center handle"
                  style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; cursor: move;"
                >
                  {{ player.player_data.first_name[0] }}. {{ player.player_data.last_name }}
                </div>
                <v-divider
                  v-if="index < players.length - 1"
                  class="my-1"
                />
              </div>
            </draggable>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'PlayerLineupCard',
  components: {
    draggable
  },
  props: {
    players: {
      type: Array,
      required: true
    },
    position: {
      type: Object,
      required: true
    }
  },
  methods: {
    updateOrder(event) {
      this.players.forEach((player, index) => {
        player.order = index + 1
      })
      this.$emit('updateOrder')
    }
  }
}
</script>
